/* naborCl14.js — věta podle čl. 14 GDPR pro PRVNÍ oslovení kandidáta z veřejného registru.
 *
 * Proč: údaje o kandidátovi nemáme od něj, ale z registru (ČNB JERRS / NBS). Čl. 14 GDPR
 * pak chce, aby se nejpozději při prvním kontaktu dozvěděl: kdo je správce, odkud údaje
 * máme, k čemu je používáme, na jakém základě, že může vznést námitku a kde najde víc.
 * Dřív zprávy uváděly jen zdroj a „víc se neozvu“ (F10, 18. 10. 2026).
 *
 * Text je rámcový (ne právní stanovisko) — znění má potvrdit právník/DPO, viz
 * docs/ZADANI-CUNG.md F10. Odkaz na plné informace (F10c, 19. 10. 2026) = veřejná stránka
 * /informace-kandidati/:slug vizitky poradce. Bez vizitky zůstane viditelná [závorka]
 * a zpráva nejde odeslat.
 */

/** Odkaz na stránku „Informace o zpracování“ (pages/InformaceKandidatiPage.js), nebo "" bez vizitky.
 *  SK kandidát dostane slovenskou verzi (?l=sk). */
export function odkazInformaci(slug, advisor, origin = (typeof window !== "undefined" ? window.location.origin : "")) {
  const s = String(slug || "").trim();
  if (!s || !origin) return "";
  return `${origin}/informace-kandidati/${encodeURIComponent(s)}${advisor?.zeme === "SK" ? "?l=sk" : ""}`;
}

/** Krátký název registru podle země kandidáta (zeme z /api/nbs = „SK“, jinak ČR). */
export function registrKandidata(advisor) {
  return advisor?.zeme === "SK" ? "NBS" : "ČNB";
}

/** Věta čl. 14 do e-mailu / LinkedInu (plná) nebo SMS (krátká). jazyk: "cs" | "sk". */
export function vetaCl14({ advisor, jazyk = "cs", kratka = false, jmenoPoradce = "", odkaz = "" }) {
  const veta = vetaCl14Text({ advisor, jazyk, kratka, jmenoPoradce });
  return odkaz ? veta.replace(/\[odkaz[^\]]*\]/g, odkaz) : veta;
}

function vetaCl14Text({ advisor, jazyk, kratka, jmenoPoradce }) {
  const reg = registrKandidata(advisor);
  const sk = jazyk === "sk";
  const kdo = (jmenoPoradce || "").trim() || (sk ? "[Vaše meno]" : "[Vaše jméno]");
  if (kratka) {
    return sk
      ? `Kontakt mám z verejného registra ${reg}, oslovujem jednorazovo (oprávnený záujem). Ak nechcete, odpíšte NIE a viac sa neozvem. Info: [odkaz]`
      : `Kontakt mám z veřejného registru ${reg}, oslovuji jednorázově (oprávněný zájem). Nechcete-li, odepište NE a víc se neozvu. Info: [odkaz]`;
  }
  return sk
    ? `Informácia o ochrane osobných údajov: Vaše meno, obec a údaje o registrácii (IČO, sektor, pre koho pracujete) mám z verejného registra ${reg}. Ako prevádzkovateľ (${kdo}) ich spracúvam len na toto oslovenie k možnej spolupráci, na základe oprávneného záujmu (čl. 6 ods. 1 písm. f) GDPR). Kedykoľvek môžete namietať — stačí odpísať „nie“, údaje vymažem (ponechám len záznam, aby som Vás už neoslovil) a viac sa neozvem. Podrobnosti: [odkaz na informácie o spracúvaní].`
    : `Informace o ochraně osobních údajů: Vaše jméno, obec a údaje o registraci (IČO, sektor, pro koho pracujete) mám z veřejného registru ${reg}. Jako správce (${kdo}) je zpracovávám jen pro toto oslovení k možné spolupráci, na základě oprávněného zájmu (čl. 6 odst. 1 písm. f) GDPR). Kdykoli můžete vznést námitku — stačí odepsat „ne“, údaje smažu (ponechám jen záznam, abych Vás už neoslovil) a víc se neozvu. Podrobnosti: [odkaz na informace o zpracování].`;
}

/** Nedoplněný odkaz nebo jméno správce — taková zpráva nesmí odejít (čl. 14 by byl neúplný). */
export const NEDOPLNENO_CL14 = /\[(odkaz|Vaše)/;

/** Text šablony pro kandidáta ze SK: šablony mluví o ČNB → u NBS kandidáta přepsat. */
export function registrDoTextu(text, advisor) {
  return registrKandidata(advisor) === "NBS" ? String(text || "").replace(/ČNB/g, "NBS") : text;
}
